// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad2707a8","228":"0ab30af3","239":"a20c3e12","667":"154c5ab7"}[chunkId] + ".chunk.js";
};